<div class="content-wrapper">
    <div class="card">
      <div class="card-body" >
        <div class="row ">
            <div class="col-md-12">
                <h4 class="card-title">Company Logo</h4>
                <p>To update the logo, simply select the logo using the file selector.</p>
            </div>
        </div>
        <div class="field-separator"></div>
        <div class="row">
            <div class="col-md-12">

                <table class="table table-borderless w-100 mt-4" >
                    <tr>
                        <td>
                            <div class="logo-image">
                                <!-- <img *ngIf="!company.logo" src="{{base}}logo-full.jpg"> -->
                                <img src="/assets/images/logo.jpg">
                            </div>
                        </td>
                        <td>
                            <input type="file" (change)="uploadLogo($event)">
                        </td>
                    </tr>
                </table>
                <div class="field-separator"></div>
                <div class="row ">
                    <div class="col-md-12">
                        <h4 class="card-title">Company Details</h4>
                    </div>
                </div>
                <form #companyForm="ngForm">
                    <table class="table table-border w-100 mt-4">
                        <tbody>
                            <tr>
                                <td><strong>Company Name </strong> </td><td> : </td><td><input name="name" id="name" class="form-control" placeholder="Company Name" ngModel required></td>
                            </tr>
                            <tr>
                                <td><strong>Trading Name </strong> </td><td> : </td><td><input name="name" id="name" class="form-control" placeholder="Company Name" ngModel required></td>
                            </tr>
                            <tr>
                                <td><strong>Address </strong> </td><td> : </td><td><input name="address" id="address" class="form-control" placeholder="Company Address" ngModel required></td>
                            </tr>
                            <tr>
                                <td><strong>Postcode </strong> </td><td> : </td><td><input name="postcode" id="postcode" class="form-control" placeholder="Company Postcode" ngModel required></td>
                            </tr>
                            <tr>
                                <td><strong>Telephone </strong> </td><td> : </td><td><input name="telephone" id="telephone" class="form-control" placeholder="Company Telephone" ngModel required></td>
                            </tr>
                            <tr>
                                <td><strong>Email </strong> </td><td> : </td><td><input name="email" id="email" class="form-control" placeholder="Company Email" ngModel required></td>
                            </tr>
                            <tr>
                                <td><strong>Registration Number </strong> </td><td> : </td><td><input name="regNumber" id="regNumber" class="form-control" placeholder="Registration Number" ngModel required></td>
                            </tr>
                            <tr>
                                <td><strong>Registration Address </strong> </td><td> : </td><td><input name="regAddress" id="regAddress" class="form-control" placeholder="Registration Address" ngModel required></td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>
        <div class="field-separator"></div>
        <div class="row">
            <div class="col-md-12">
                <div class="button-row">
                    <button  class="btn btn-primary btn-block" [disabled]="companyForm.invalid">Update Company</button>
                </div>
            </div>
        </div>
    </div>
 </div>
</div>